// Parse social media URLs -> embeddable iframe URL + platform metadata

export function detectPlatform(url) {
  if (!url) return null;
  const u = url.toLowerCase();
  if (u.includes("tiktok.com")) return "tiktok";
  if (u.includes("instagram.com")) return "instagram";
  if (u.includes("youtube.com") || u.includes("youtu.be")) return "youtube";
  return null;
}

function matchGroup(url, re) {
  const m = url.match(re);
  return m ? m[1] : null;
}

export function parseEmbed(url) {
  if (!url) return null;
  const platform = detectPlatform(url);
  if (!platform) return null;

  if (platform === "tiktok") {
    // https://www.tiktok.com/@user/video/7426273868341431585
    // https://www.tiktok.com/t/ZPR...
    const id = matchGroup(url, /\/video\/(\d+)/);
    if (!id) return null;
    return {
      platform: "tiktok",
      label: "TikTok",
      videoId: id,
      embedUrl: `https://www.tiktok.com/embed/v2/${id}`,
      // Thumbnail via TikTok oEmbed requires API call – we rely on iframe native preview
      thumbnailUrl: null,
      pageUrl: url,
      aspect: "9/16",
    };
  }

  if (platform === "instagram") {
    // https://www.instagram.com/reel/CODE/
    // https://www.instagram.com/reels/CODE/
    // https://www.instagram.com/p/CODE/
    const code =
      matchGroup(url, /\/reels?\/([A-Za-z0-9_-]+)/) ||
      matchGroup(url, /\/p\/([A-Za-z0-9_-]+)/);
    if (!code) return null;
    const isReel = /\/reels?\//.test(url);
    return {
      platform: "instagram",
      label: "Instagram",
      videoId: code,
      embedUrl: `https://www.instagram.com/${isReel ? "reel" : "p"}/${code}/embed`,
      thumbnailUrl: null,
      pageUrl: url,
      aspect: "9/16",
    };
  }

  if (platform === "youtube") {
    // youtu.be/ID, youtube.com/watch?v=ID, youtube.com/shorts/ID, youtube.com/embed/ID
    const id =
      matchGroup(url, /youtu\.be\/([A-Za-z0-9_-]{6,})/) ||
      matchGroup(url, /[?&]v=([A-Za-z0-9_-]{6,})/) ||
      matchGroup(url, /\/shorts\/([A-Za-z0-9_-]{6,})/) ||
      matchGroup(url, /\/embed\/([A-Za-z0-9_-]{6,})/);
    if (!id) return null;
    const isShort = /\/shorts\//.test(url);
    return {
      platform: "youtube",
      label: "YouTube",
      videoId: id,
      embedUrl: `https://www.youtube-nocookie.com/embed/${id}?rel=0&modestbranding=1`,
      thumbnailUrl: `https://img.youtube.com/vi/${id}/hqdefault.jpg`,
      pageUrl: url,
      aspect: isShort ? "9/16" : "16/9",
    };
  }

  return null;
}

export const platformColor = {
  tiktok: "#fe2c55",
  instagram: "#e1306c",
  youtube: "#ff0033",
};
